export const initBlockData = {
  title: "Latest News",
};

export const initEmptyBlockData = {
  title: "",
};
